import * as React from 'react';
import { useLazyQuery } from '@apollo/client';
import { FormControlLabel, Checkbox } from '@mui/material';
import { GetInterruptionsOutput, GET_INTERUPTIONS } from 'api';
import { useApolloErrorHandler } from 'hooks/useApolloErrorHandler';
import { t } from 'i18next';
import { interruptionModel } from 'model';
import { TXT_INTERRUPTIONS } from '../../../../../shared/translations';
import { capitalizeFirstLetterEveryword } from 'shared/stringFunctions';

interface InterruptionsCheckboxProps {
  calculationId?: string;
  onChange: (interruptions?: interruptionModel[]) => void;
  onLoadingCompleted: () => void;
}

const getFilter = (calculationId?: string) => {
  const result = {
    laytimeCalculationId: {
      eq: calculationId || '00000000-0000-0000-0000-000000000000'
    }
  };
  return result;
};

export const InterruptionsCheckbox = (props: InterruptionsCheckboxProps) => {
  const [loading, setLoading] = React.useState<boolean>(true);
  const { apolloErrorHandler } = useApolloErrorHandler();
  const [interruptions, setInterruptions] = React.useState<interruptionModel[]>([]);
  const [getInterruptionDefinitions, { data, refetch }] = useLazyQuery<GetInterruptionsOutput>(GET_INTERUPTIONS, {
    fetchPolicy: 'network-only',
    variables: {
      where: getFilter(props.calculationId)
    },
    onError: apolloErrorHandler,
    onCompleted: (data) => {
      setInterruptions(data.interruptions);
      setLoading(false);
      props.onLoadingCompleted();
    }
  });

  React.useEffect(() => {
    if (!props.calculationId) {
      return;
    }
    fetch();
  }, [!props.calculationId]);

  const fetch = () => {
    if (!refetch) {
      getInterruptionDefinitions();
    } else {
      refetch();
    }
  };

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
    if (checked) {
      props.onChange(interruptions);
    } else {
      props.onChange(undefined);
    }
  };

  return (
    <FormControlLabel
      disabled={loading}
      label={'' + data?.interruptions.length + ' ' + capitalizeFirstLetterEveryword(t(TXT_INTERRUPTIONS))}
      control={<Checkbox onChange={handleOnChange}></Checkbox>}
    ></FormControlLabel>
  );
};
